import { match } from "ts-pattern";
import { ControlDataTypeKey } from "./control-data-type-key";
const ColorControlDataTypeKey = ControlDataTypeKey;
const ColorControlDataTypeValueV1 = "color::v1";
const ColorControlType = "makeswift::controls::color";
function Color(config = {}) {
  return { type: ColorControlType, config, version: 1 };
}
function copyColorData(value, context) {
  if (value == null)
    return value;
  return match(value).with({ [ColorControlDataTypeKey]: ColorControlDataTypeValueV1 }, (val) => ({
    ...val,
    swatchId: context.replacementContext.swatchIds.get(val.swatchId) ?? val.swatchId
  })).otherwise((val) => ({
    ...val,
    swatchId: context.replacementContext.swatchIds.get(val.swatchId) ?? val.swatchId
  }));
}
export {
  Color,
  ColorControlDataTypeKey,
  ColorControlDataTypeValueV1,
  ColorControlType,
  copyColorData
};
//# sourceMappingURL=color.js.map